/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskBlocksGet } from "../funcs/riskBlocksGet.js";
import { riskBlocksSubmitFeedback } from "../funcs/riskBlocksSubmitFeedback.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RiskBlock } from "../models/components/riskblock.js";
import {
  GetRiskBlockRequest,
  GetRiskBlockSecurity,
} from "../models/operations/getriskblock.js";
import {
  SubmitRiskBlockFeedbackRequest,
  SubmitRiskBlockFeedbackSecurity,
} from "../models/operations/submitriskblockfeedback.js";
import { unwrapAsync } from "../types/fp.js";

export class Blocks extends ClientSDK {
  /**
   * getRiskBlock risk
   *
   * @remarks
   * Get a tool call block by its risk result ID for the durable block page.
   */
  async get(
    request: GetRiskBlockRequest,
    security?: GetRiskBlockSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskBlock> {
    return unwrapAsync(riskBlocksGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * submitRiskBlockFeedback risk
   *
   * @remarks
   * Record thumbs-up/thumbs-down feedback for a tool call block from the block page.
   */
  async submitFeedback(
    request: SubmitRiskBlockFeedbackRequest,
    security?: SubmitRiskBlockFeedbackSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskBlock> {
    return unwrapAsync(riskBlocksSubmitFeedback(
      this,
      request,
      security,
      options,
    ));
  }
}
